import React from 'react';
import { TableRow, TableCell, withStyles, IconButton } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@material-ui/icons';

const styles = (theme) => ({
  proNumberContainer: {
    height: '24px',
    backgroundColor: theme.statusHeadBGColor
  },
  driverStatusHeaderCell: {
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: '10px',
    color: theme.proNumbers
  },
  proNumbers: {
    float: 'left',
    paddingTop: 3,
    paddingLeft: '10px',
    overflow: 'hidden',
    lineHeight: '17px',
    width: '210px',
    textOverflow: 'ellipsis'
  },
  expand: {
    marginLeft: 'auto',
    color: theme.proNumbers,
    float: 'right',
    padding: 0,
    margin: '0 7 0 0'
  },
  accountNumber: {
    fontSize: '12px'
  },
  clickable: {
    textDecoration: 'underline'
  }
});

class ShowPickupNumbers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded
    }));
  };

  handlePickupNumberClick = (pickup) => {
    const { glEventHub, pickupNumberIdList, groupId } = this.props;
    const pickupIdsOnRow = pickupNumberIdList.map((p) => p?.pickupId).filter(Boolean);
    const isMultiPickupGroupRow = pickupIdsOnRow.length > 1;
    if (isMultiPickupGroupRow && this.props.enableBulkEditAndVoid) {
      if (groupId) {
        glEventHub.emit('showPickupDetails', { groupId: String(groupId).toUpperCase() });
        return;
      }
    }
    if(pickup.pickupId) {
      glEventHub.emit('showPickupDetails', pickup.pickupId);
    }
  };

  renderPickupNumbers = (pickupNumberIdList) => {
    const { classes } = this.props;
    return pickupNumberIdList.map((pickup, index) => (
      <React.Fragment key={pickup.pickupId}>
        <span
          className={`${classes.accountNumber} ${classes.clickable}`}
          onClick={() => this.handlePickupNumberClick(pickup)}>
          {pickup.pickupNumber ?? ''}
        </span>
        {index < pickupNumberIdList.length - 1 && ", "}
      </React.Fragment>
    ));
  };

  shouldShowExpandButton = () => {
    const { pickupNumberIdList } = this.props;
    return pickupNumberIdList.length > 2;
  };

  getDisplayList = () => {
    const { pickupNumberIdList } = this.props;
    return this.state.expanded ? pickupNumberIdList : pickupNumberIdList.slice(0, 2);
  };

  render() {
    const { classes } = this.props;
    
    return (
      <TableRow className={classes.proNumberContainer}>
        <TableCell colSpan={2} className={classes.driverStatusHeaderCell}>
          <div className={classes.proNumbers}>
            Pickup#:{' '}
            {this.renderPickupNumbers(this.getDisplayList())}
          </div>
          {this.shouldShowExpandButton() && (
            <IconButton className={classes.expand} onClick={this.handleExpandClick}>
              {this.state.expanded ? (
                <ExpandLessIcon className={classes.expandIcon} />
              ) : (
                <ExpandMoreIcon className={classes.expandIcon} />
              )}
            </IconButton>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(styles)(ShowPickupNumbers);
